<div class="block-title">
    <div class="d-flex align-items-center">
        <div class="logo-icon"></div>
        <div class="d-flex align-items-center">
            <h3 class="d-inline mr-3">
                <a [routerLink]="['/discovery']">
                    <span>发现</span>
                </a>
            </h3>
            <div class="mr-3 d-flex align-items-center try-button" (click)="changeHots()">
                <i class="iconfont iconhuanyihuan"></i>
                换一波
            </div>
        </div>
    </div>
</div>
<div class="meta-container" [ngClass]="{'no-bg':hot.length>0}">
    <ng-container *ngIf="hot.length > 0">
        <div class="meta-box" *ngFor="let item of hotshadow; let i = index"
            [ngClass]="{'hidden-lg':i>=14,'hidden-md hidden-sm':i>=12}">
            <ng-container #metaList></ng-container>
            <div class="loader-ctn" *ngIf="isHotLoading">
                <app-loader-spinner></app-loader-spinner>
            </div>
        </div>
    </ng-container>
</div>

<div class="discovery-shadow" [hidden]="!shadowOpen">
    <div style="height: inherit;">
        <ng-container #activityBox></ng-container>
        <!-- <app-activity-detail style="height: inherit;" [detailData]="detailData" (closeDetail)="closeHandler($event)">
        </app-activity-detail> -->
    </div>
</div>